import { GLOBAL_LOADER_STEP } from '@client/enums';

import { accessingSigEditor } from './accessing-sig-editor';
import { editingSignature } from './editing-sig';
import { addingField, hidingField, managingFields, removingField, reorderingField } from './fields';
import { changingHtmlCss } from './html-css';
import { menuOptions } from './options';
import { previewingChanges, previewSettings } from './preview';
import { darkMode, proTip, unparsedPreview } from './pro-tip';
import { savingSignature } from './save';
import { sigEditorA, sigEditorB } from './sig-editor';
import { updatingSignature } from './updating-sig';

let editSteps = [
  editingSignature,
  accessingSigEditor,
  menuOptions,
  GLOBAL_LOADER_STEP,
  updatingSignature,
  changingHtmlCss,
  sigEditorA,
  sigEditorB,
  proTip,
  unparsedPreview,
  darkMode,
  managingFields,
  addingField,
  removingField,
  hidingField,
  reorderingField,
  previewingChanges,
  previewSettings,
  savingSignature
];

editSteps[3] = {
  ...editSteps[3],
  popover: {
    ...editSteps[3].popover,
    title: 'Loading signature...'
  }
};

export const EDIT_STEPS = editSteps;
